import React from 'react'
import { TagFilter } from './TagFilter'

const component = 'tag-filter'

export function TagFilters({ filters, handleFilterCallback, activeFilter, resultCount, allLabel = 'All' }) {
    if (typeof handleFilterCallback !== 'function') {
        return null
    }
    return (
        <div className={`${component}__filters`}>
            <TagFilter
                isActive={activeFilter === ''}
                onClickCallback={() => {
                    handleFilterCallback('')
                }}
                key={'all'}
                label={document.documentElement.lang === 'ja' ? 'すべて' : allLabel}
                doc_count={resultCount}
            />
            {filters &&
                filters.map((filter) => (
                    <TagFilter
                        isActive={activeFilter === filter.key}
                        onClickCallback={() => {
                            handleFilterCallback(filter.key)
                        }}
                        key={filter.key}
                        {...filter}
                    />
                ))}
        </div>
    )
}
